export default __webpack_public_path__ + "static/media/bedroom-4.935d747d.png";